import ElementUI from 'element-ui'
import jsrsasign from 'jsrsasign'

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoqBOSB8KSn+rQscTVhpz
a1UcQ+1ZS5xQaZFg4XReqOMrynbslDV7LbIMQ15FkS/wzVHyYNm7Nkj+JZhl3JIF
hUuDdT/cjOGKRfTbWBPpzw6vr4PzLwMLx77Vs8jkTwRxsZKJ7TcIlRSsly9GT0l1
kVg4sICLSFk4F3ab9+y1sA17pH6kpCWk9tGLSofU6kP1ycRDeIZ33o+9WSMxmsvX
lFKEyA+I04VlByfSD8FwCwvxLp/MpKoCA8jFxNMFmivNBDuKdC1cpGUOjtRRFbKI
KfvNXyB8gAvu0iwi0gsbcMwPa7VxRAlXANe2OsIJ2YGdacXjJwlJU9oBDI/DP3yZ
pwIDAQAB
-----END PUBLIC KEY-----`

const PROTECTED_URLS = [
  '/login',
  '/get_user_info',
  '/user_permissions',
  '/user_permission',
]

function verifySignature(data, signatureBase64) {
  const pub = jsrsasign.KEYUTIL.getKey(PUBLIC_KEY)
  const sig = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
  sig.init(pub)
  sig.updateString(data)
  return sig.verify(jsrsasign.b64tohex(signatureBase64))
}

function isProtectedUrl(url) {
  if (!url) return false
  return PROTECTED_URLS.some((u) => url.includes(u))
}

function getRawResponseData(response) {
  if (response.request?.responseText) {
    return response.request.responseText
  }
  return typeof response.data === 'string'
    ? response.data
    : JSON.stringify(response.data)
}

function handleVerifyFailure(url) {
  ElementUI.Message({
    duration: 2000,
    message: '接口参数存在异常，将退出登录',
    type: 'error',
  })
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('refresh_token')
  // 动态 import 避免与 request.ts 形成编译期循环依赖
  import('@/router').then(({ default: router }) => {
    if (router.currentRoute.path !== '/login') {
      router.replace('/login')
    }
  })
}

function verifyResponseSignature(response) {
  if (!isProtectedUrl(response.config?.url)) return response

  const headers = response.headers
  const signature =
    typeof headers?.get === 'function'
      ? headers.get('x-signature')
      : headers?.['x-signature']

  let isInvalid = false

  if (!signature) {
    isInvalid = true
  } else {
    const rawData = getRawResponseData(response)
    isInvalid = !verifySignature(rawData, signature)
  }

  if (isInvalid) {
    handleVerifyFailure(response.config?.url)
    response.data = { status: 0, msg: '接口参数存在异常，将退出登录' }
    return response
  }

  return response
}

export { verifyResponseSignature, verifySignature, isProtectedUrl }
